export default __webpack_public_path__ + "static/media/dropdown-arrow-down.cd4830fe.svg";